// komponent wyświetlający drzewo katalogowe
// @ts-nocheck

import React, { useRef, useState } from "react";
import { ChevronRight, ChevronLeft } from "react-bootstrap-icons";
import classnames from "classnames";

import { useGetLayoutCategories } from "api";
import { ICategoryListItem } from "api/types";
import { Link, Loader } from "components/controls";
import { FolderOpenIcon } from "assets/icons";
import { useRWD } from "hooks";
import subcategoriesBanner from "assets/images/subcategories-banner.jpg";

import styles from "theme/components/layouts/MainLayout/components/HeaderBottomBar/CategoryTree/CategoryTree.module.scss";

interface CategoryTreeProps {
  onCategoryClick?: () => void;
  onSubcategoriesViewChange?: (isOpen: boolean) => void;
}

const CategoryTree: React.FC<CategoryTreeProps> = ({ onCategoryClick, onSubcategoriesViewChange }) => {
  const subcategoryRefs = useRef<{ [key: number]: HTMLDivElement | null }>({});
  const [activeCategoryId, setActiveCategoryId] = useState<number | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<ICategoryListItem | null>(null);
  const { isMobile } = useRWD();
  // pobranie listy kategorii
  const { data: categoriesData, isLoading } = useGetLayoutCategories({
    page: 1,
    limit: 999,
    search_keyword: "",
  });

  // zbieranie wszystkich kategorii głównych
  const mainCategories: ICategoryListItem[] = [];
  categoriesData?.items.forEach((category) => {
    if (category.categories_list && category.show_category_button) {
      mainCategories.push(...category.categories_list);
    }
  });

  // funkcja otwierająca popover dla kategorii (desktop)
  const handleCategoryOpen = (categoryId: number, element: HTMLElement) => {
    const container = subcategoryRefs.current[categoryId];
    if (container) {
      const rect = element.getBoundingClientRect();
      container.style.left = `${rect.right}px`;
      container.style.top = `${rect.top}px`;
      setActiveCategoryId(categoryId);
    }
  };

  // funkcja otwierająca widok podkategorii na mobile
  const handleCategoryClick = (category: ICategoryListItem) => {
    if (isMobile && category.subcategories_total_count > 0) {
      setSelectedCategory(category);
      onSubcategoriesViewChange?.(true);
    }
  };

  // funkcja cofająca do widoku głównego na mobile
  const handleBackClick = () => {
    setSelectedCategory(null);
    onSubcategoriesViewChange?.(false);
  };

  // Renderowanie widoku podkategorii na mobile
  if (isMobile && selectedCategory) {
    return (
      <div className={styles.mobileSubcategoriesView}>
        <div className={styles.mobileSubcategoriesHeader}>
          <button className={styles.backButton} onClick={handleBackClick}>
            <ChevronLeft />
          </button>
          <h2 className={styles.categoryTitle}>{selectedCategory.name}</h2>
        </div>
        <div className={styles.mobileSubcategoriesList}>
          {selectedCategory.subcategories?.map((subcategory) => (
            <Link
              key={subcategory.id}
              to={`/${subcategory.url_link}`}
              onClick={onCategoryClick}
              className={styles.mobileSubcategoryItem}
            >
              {subcategory.name}
            </Link>
          ))}
        </div>
        <div className={styles.mobileSubcategoriesBanner}>
          <img
            src={subcategoriesBanner}
            alt="Banner"
            className={styles.bannerImage}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className={styles.categoryTreeContainer}>
        <div className={styles.categoryTreeScroll}>
          {mainCategories.map((category) => {
            const hasSubcategories = category.subcategories_total_count > 0;

            return (
              <div
                key={category.id}
                className={classnames(styles.mainCategoryRow, {
                  [styles.hasSubcategories]: hasSubcategories,
                })}
                onMouseEnter={(e) => {
                  if (!isMobile && hasSubcategories) {
                    handleCategoryOpen(category.id, e.currentTarget);
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    // zamykamy po krótkim opóźnieniu, aby umożliwić przejście do popovera
                    setTimeout(() => {
                      setActiveCategoryId((prev) => prev === category.id ? null : prev);
                    }, 200);
                  }
                }}
                onClick={(e) => {
                  if (isMobile && hasSubcategories) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCategoryClick(category);
                  } else if (!isMobile && hasSubcategories) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCategoryOpen(category.id, e.currentTarget);
                  }
                }}
              >
                <div className={styles.categoryIcon}>
                  <FolderOpenIcon />
                </div>
                <div className={styles.categoryName}>
                  {hasSubcategories ? (
                    <span
                      className={classnames(styles.categoryNameText, {
                        [styles.chosen]: category.id === undefined,
                      })}
                    >
                      {category.name}
                      {/* {" "}
                      <span className={styles.counter}>
                        ({category.products_count})
                      </span> */}
                    </span>
                  ) : (
                    <Link
                      to={`/${category.url_link}`}
                      onClick={onCategoryClick}
                      className={classnames({
                        [styles.chosen]: category.id === undefined,
                      })}
                    >
                      {category.name}{" "}
                      <span className={styles.counter}>
                        ({category.products_count})
                      </span>
                    </Link>
                  )}
                </div>
                {hasSubcategories && (
                  <>
                    <div className={styles.categoryArrow}>
                      <ChevronRight />
                    </div>
                    <div
                      ref={(el) => {
                        subcategoryRefs.current[category.id] = el;
                      }}
                      className={classnames(styles.subcategoriesContainer, {
                        [styles.active]: activeCategoryId === category.id,
                      })}
                      onMouseEnter={() => {
                        setActiveCategoryId(category.id);
                      }}
                      onMouseLeave={() => {
                        setActiveCategoryId(null);
                      }}
                    >
                      <div className={styles.subcategoriesContent}>
                        <div className={styles.subcategoriesMain}>

                          <div className={styles.subcategoriesHeader}>
                            <Link
                              to={`/${category.url_link}`}
                              onClick={onCategoryClick}
                              className={styles.subcategoriesHeaderLink}
                            >
                              {category.name}
                            </Link>
                          </div>

                          <div className={styles.subcategoriesBody}>
                            <div>
                              {category.subcategories?.map((subcategory) => (
                                <div
                                  key={subcategory.id}
                                  className={styles.subcategoryItem}
                                >
                                  <Link
                                    to={`/${subcategory.url_link}`}
                                    onClick={onCategoryClick}
                                    className={classnames({
                                      [styles.chosen]: subcategory.id === undefined,
                                    })}
                                  >
                                    {subcategory.name}
                                    {/* {" "}
                                    <span className={styles.counter}>
                                      ({subcategory.products_count})
                                    </span> */}
                                  </Link>
                                </div>
                              ))}
                            </div>

                            <div className={styles.subcategoriesBanner}>
                              <img
                                src={subcategoriesBanner}
                                alt="Banner"
                                className={styles.bannerImage}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CategoryTree;
